"use client"

import Link from "next/link"
import {cn} from "@/lib/utils"

interface ButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    variant?: 'outline' | 'solid' | 'secondary'
}

const ButtonLink: React.FC<ButtonLinkProps> = ({variant, children, className, ...props }) => {

    const baseClasses = "inline-flex h-10 items-center justify-center rounded-md text-sm font-medium shadow-sm transition-colors focus-visible:outline-hidden focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90 dark:focus-visible:ring-slate-300"
    
    const variantClasses = variant === "outline"
        ? "border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 focus-visible:ring-slate-950 px-4 md:px-6"
        : variant === "secondary" 
            ? "px-2 bg-slate-100 hover:bg-slate-50 focus-visible:ring-slate-950" 
            : "bg-popadvise text-slate-50 hover:bg-popadvise/90 focus-visible:ring-slate-950 px-3 md:px-4 lg:px-6"

    const allClasses = cn(baseClasses, variantClasses, className)

    return (
        <Link
            className={allClasses}
            href={props.href as string}
            {...props}
        >
            {children}
        </Link>
    )
}

export default ButtonLink